import { useEffect, useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { UsageMeter } from "@/components/UsageMeter";
import { SkeletonCard } from "@/components/Skeletons";
import { Check } from "lucide-react";
import client from "@/lib/api";

export default function Account() {
    const [data, setData] = useState(null);

    useEffect(() => {
        client.get("/account").then(({ data }) => setData(data)).catch(() => setData(false));
    }, []);

    if (!data) return (<><PageHeader title="Mi cuenta" /><SkeletonCard /></>);

    const isPremium = data.plan === "premium";

    return (
        <div className="mx-auto max-w-3xl">
            <PageHeader title="Mi cuenta y plan"
                subtitle="Aquí ves tu plan y cuánto llevas usado. Sin sorpresas: te avisamos antes de llegar al límite." />

            <div className="rounded-lg border border-line bg-card p-6">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-[13px] uppercase tracking-wide text-subtle">Tu plan</p>
                        <p className="text-[22px] font-bold tracking-tight text-ink">
                            {isPremium ? data.plan_premium_name : data.plan_free_name}
                        </p>
                    </div>
                    <span className="rounded-full border border-line bg-background px-3 py-1 text-[13px] font-medium text-ink">
                        {isPremium ? data.plan_premium_price : data.plan_free_price}
                    </span>
                </div>

                {!isPremium && (
                    <div className="mt-6 grid gap-3 sm:grid-cols-3">
                        <UsageMeter label="Análisis" used={data.usage.analyses} max={data.limits.analyses} />
                        <UsageMeter label="Productos" used={data.usage.products} max={data.limits.products} />
                        <UsageMeter label="Informes" used={data.usage.reports} max={data.limits.reports} />
                    </div>
                )}
            </div>

            {!isPremium && (
                <div className="mt-6 rounded-lg border border-line bg-ink p-6 text-cream">
                    <div className="flex items-baseline justify-between">
                        <h3 className="text-[20px] font-bold tracking-tight">{data.plan_premium_name}</h3>
                        <span className="tnum text-[15px] font-medium text-cream/80">{data.plan_premium_price}</span>
                    </div>
                    <p className="mt-2 text-[14px] leading-[1.6] text-cream/70">
                        Cuando esté disponible, tendrás análisis, productos e informes sin límite, y el
                        seguimiento completo de tu evolución.
                    </p>
                    <ul className="mt-4 space-y-2 text-[14px]">
                        {["Análisis de piel ilimitados", "Neceser sin límite de productos",
                          "Todos los informes que quieras", "Recordatorios para no perder el hilo"].map((f) => (
                            <li key={f} className="flex items-center gap-2">
                                <Check size={16} className="text-terracotta" /> {f}
                            </li>
                        ))}
                    </ul>
                    <div className="mt-5">
                        <span className="inline-block rounded-lg bg-cream/10 px-4 py-2 text-[14px] font-medium text-cream" data-testid="premium-soon">
                            Disponible muy pronto
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
}
